module.exports = __webpack_public_path__ + "static/media/play-icon.e550c490.svg";